export default {
    name: '学习进度',
    permissionsKey:"YY-XXJD",
    icon: 'fa fa-area-chart',
    children: {
        courseList:{
            name: '学习进度',
            permissionsKey:"YY-XXJD-XXJD",
            path: '/study_progress/progress_list',
        },
    }
};
